import { useEffect } from "react";

const SCRIPT_ID = "structured-data";

// Injects a JSON-LD <script> into <head> for the current route, replacing
// it on navigation and removing it on unmount. CRA has no SSR, but Google
// executes JS when crawling, so this is picked up the same as static JSON-LD.
export default function useStructuredData(schema) {
  useEffect(() => {
    if (!schema) return;

    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    return () => {
      script.remove();
    };
  }, [schema]);
}
